module.exports = __webpack_public_path__ + "img/thumb1.1da0bbf7.png";